<template>
    <VJoyPanel>
        <template #panel-title>{{ $msg('customer.brief.form.overview.tips.step') }}</template>
        <template #panel-body>
            <ol class="step-list">
                <li>{{ $msg('customer.brief.form.overview.tips.v2.step.one') }}</li>
                <li>{{ $msg('customer.brief.form.overview.tips.v2.step.two') }}</li>
            </ol>
        </template>
    </VJoyPanel>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
    @use '~@malt/joy-entrypoint/src/sass/base/2_mixins/text';
    @use '~@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .malty-illu {
        text-align: center;
        margin-bottom: 20px;
    }

    ol.step-list {
        counter-reset: item;
        margin: 32px 0 0 0;
        padding: 0;

        > li {
            display: block;
            margin: 14px 0;
            @include text.getFontBySize(primary-300);

            &:before {
                content: counter(item) '. ';
                counter-increment: item;
                color: var(--joy-color-primary-30);
            }
        }
    }
</style>
